// PnlWebSocketListener.jsx
import React, { useEffect, useRef } from "react";
const BASE_HTTP_URL = process.env.REACT_APP_SERVER_URL;

const WEBSOCKET_URL = `${BASE_HTTP_URL.replace(/^http/, "ws")}/ws/pnl/`;
console.log("WebSocketURL", WEBSOCKET_URL);


const PnlWebSocketListener = ({ onPnlUpdate, enabled = true }) => {
  const wsRef = useRef(null);

  useEffect(() => {
    // SSR / server-render guard (Next.js ya similar ho to)
    if (typeof window === "undefined") {
      return;
    }

    if (!enabled) {
      return;
    }

    const ws = new WebSocket(WEBSOCKET_URL);
    wsRef.current = ws;

    ws.onopen = () => {
      console.log("[WS] ✅ WebSocket connected");
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data && data.trade_id) {
          if (typeof onPnlUpdate === "function") {
            onPnlUpdate(data);
          }
        }
      } catch (err) {
        console.error("[WS] JSON parse error:", err);
      }
    };

    ws.onerror = (err) => {
      console.error("[WS] WebSocket error:", err);
    };

    ws.onclose = (event) => {
      wsRef.current = null;
    };

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [onPnlUpdate, enabled]);

  return null;
};

export default PnlWebSocketListener;
